// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SelectOptionStepQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type SelectOptionStepQuery = { __typename?: 'Query', projectReadyPlanConfig: { __typename?: 'ProjectReadyPlanConfig', id: string, productOffering?: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined } | null | undefined, potentialOptionGroups: Array<{ __typename?: 'ProjectReadyPlanConfigPotentialOptionGroup', id: string, group: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isAddOnV2?: boolean | null | undefined, isStructuralV2?: boolean | null | undefined, isProductOptionV2: boolean, isPackageOptionV2: boolean } } }, options: Array<{ __typename?: 'ProjectReadyPlanConfigPotentialOption', id: string, totalCostInCents: number, isSelected: boolean, canBeSelected: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, option: { __typename?: 'ReadyPlanOption', id: string, code: string, maybeShortName: string, location?: { __typename?: 'Location', id: string, pathArray: Array<string> } | null | undefined } }> }> } };

export type SelectOptionStep_PotentialOptionGroupFragment = { __typename?: 'ProjectReadyPlanConfigPotentialOptionGroup', id: string, group: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isAddOnV2?: boolean | null | undefined, isStructuralV2?: boolean | null | undefined, isProductOptionV2: boolean, isPackageOptionV2: boolean } } }, options: Array<{ __typename?: 'ProjectReadyPlanConfigPotentialOption', id: string, totalCostInCents: number, isSelected: boolean, canBeSelected: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, option: { __typename?: 'ReadyPlanOption', id: string, code: string, maybeShortName: string, location?: { __typename?: 'Location', id: string, pathArray: Array<string> } | null | undefined } }> };

export type SelectOptionStep_PotentialOptionFragment = { __typename?: 'ProjectReadyPlanConfigPotentialOption', id: string, totalCostInCents: number, isSelected: boolean, canBeSelected: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, option: { __typename?: 'ReadyPlanOption', id: string, code: string, maybeShortName: string, location?: { __typename?: 'Location', id: string, pathArray: Array<string> } | null | undefined } };

export type SelectOptionStep_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, code: string, maybeShortName: string, location?: { __typename?: 'Location', id: string, pathArray: Array<string> } | null | undefined };

export const SelectOptionStep_ReadyPlanOptionFragmentDoc = gql`
    fragment SelectOptionStep_ReadyPlanOption on ReadyPlanOption {
  id
  code
  maybeShortName
  location {
    id
    pathArray
  }
}
    `;
export const SelectOptionStep_PotentialOptionFragmentDoc = gql`
    fragment SelectOptionStep_PotentialOption on ProjectReadyPlanConfigPotentialOption {
  id
  totalCostInCents
  isSelected
  canBeSelected {
    ...PotentialOperationDetails
  }
  option {
    ...SelectOptionStep_ReadyPlanOption
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${SelectOptionStep_ReadyPlanOptionFragmentDoc}`;
export const SelectOptionStep_PotentialOptionGroupFragmentDoc = gql`
    fragment SelectOptionStep_PotentialOptionGroup on ProjectReadyPlanConfigPotentialOptionGroup {
  id
  group {
    id
    order
    name
    group {
      id
      type {
        id
        isAddOnV2
        isStructuralV2
        isProductOptionV2
        isPackageOptionV2
      }
    }
  }
  options {
    ...SelectOptionStep_PotentialOption
  }
}
    ${SelectOptionStep_PotentialOptionFragmentDoc}`;
export const SelectOptionStepDocument = gql`
    query SelectOptionStep($projectId: ID!) {
  projectReadyPlanConfig(projectId: $projectId) {
    id
    productOffering {
      id
      aggregateCheckout {
        id
        version
      }
    }
    potentialOptionGroups {
      ...SelectOptionStep_PotentialOptionGroup
    }
  }
}
    ${SelectOptionStep_PotentialOptionGroupFragmentDoc}`;

/**
 * __useSelectOptionStepQuery__
 *
 * To run a query within a React component, call `useSelectOptionStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectOptionStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectOptionStepQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSelectOptionStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectOptionStepQuery, SelectOptionStepQueryVariables> & ({ variables: SelectOptionStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectOptionStepQuery, SelectOptionStepQueryVariables>(SelectOptionStepDocument, options);
      }
export function useSelectOptionStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectOptionStepQuery, SelectOptionStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectOptionStepQuery, SelectOptionStepQueryVariables>(SelectOptionStepDocument, options);
        }
// @ts-ignore
export function useSelectOptionStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectOptionStepQuery, SelectOptionStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectOptionStepQuery, SelectOptionStepQueryVariables>;
export function useSelectOptionStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectOptionStepQuery, SelectOptionStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectOptionStepQuery | undefined, SelectOptionStepQueryVariables>;
export function useSelectOptionStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectOptionStepQuery, SelectOptionStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectOptionStepQuery, SelectOptionStepQueryVariables>(SelectOptionStepDocument, options);
        }
export type SelectOptionStepQueryHookResult = ReturnType<typeof useSelectOptionStepQuery>;
export type SelectOptionStepLazyQueryHookResult = ReturnType<typeof useSelectOptionStepLazyQuery>;
export type SelectOptionStepSuspenseQueryHookResult = ReturnType<typeof useSelectOptionStepSuspenseQuery>;
export type SelectOptionStepQueryResult = ApolloReactCommon.QueryResult<SelectOptionStepQuery, SelectOptionStepQueryVariables>;